import moment from 'moment';

import { SERVER_NAME_REPLACEMENT } from './constants';

const minImageServer = 0;
const maxImageServer = 2;
let currentImageServer = 0;

export const onlyNumbers = (param = '') => {
  const value = `${param || ''}`;

  if (!(value && value.length)) {
    return '';
  }

  return value.match(/\d/g).join('');
};

export const onlyAlphaNumeric = (param = '') => {
  const value = `${param || ''}`;

  if (!(value && value.length)) {
    return '';
  }

  return value.replace(/[^A-Za-z0-9]*/g, '');
};

export const formatThousands = value => {
  if (!value) {
    return '';
  }

  return value
    .toString()
    .replace('.', ',')
    .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};

export const formatImageUrl = id => {
  currentImageServer = (() => {
    if (currentImageServer >= maxImageServer) {
      return minImageServer;
    }

    return currentImageServer + 1;
  })();

  const imageURL = process.env.REACT_APP_IMAGE_URL.replace(
    SERVER_NAME_REPLACEMENT,
    currentImageServer
  );

  if (process.env.REACT_APP_IMAGE_DEV === 'true') {
    if (imageURL.startsWith('0')) return `${imageURL}/2/${id}`;

    return `${imageURL}2/0${id}`;
  }

  return `${imageURL}2/${id}`;
};

export const formatPhone = value => {
  const cleanValue = value.toString().replace(' ', '');
  const ddd = cleanValue.substring(0, 2);
  const phoneNumber = cleanValue.substring(2, cleanValue.length);

  if (phoneNumber.length === 8) {
    return `(${ddd}) ${phoneNumber.substring(0, 4)}-${phoneNumber.substring(4, 8)}`;
  }
  if (phoneNumber.length === 9) {
    return `(${ddd}) ${phoneNumber.substring(0, 5)}-${phoneNumber.substring(5, 9)}`;
  }
  return `(${ddd}) ${phoneNumber}`;
};

export const formatShortDate = timestamp => moment(timestamp).format('DD/MM/YYYY');

export const formatDateToGlobalPattern = date => {
  const [day, month, year] = date.split('/');

  return `${month}/${day}/${year}`;
};

export const formatTimezone = time => moment(`01/01/1970 ${time}`).format('HH:mm');

export const formatMileage = value => {
  if (!value) {
    return '-';
  }

  return `${formatThousands(value)} km`;
};

export const formatMoney = value => {
  if (!value) {
    return '-';
  }

  return `R$ ${formatThousands(Number(value).toFixed(2))}`;
};

export const formatMoneyToFloat = (value = '') =>
  Number(value.replace('R$', '').replace(' ', '').replace(/\./g, '').replace(',', '.'));

export const formatPhoneToInt = (value = '') =>
  Number(value.replace('(', '').replace(')', '').replace(' ', '').replace('-', ''));

export const formatCarPlate = value => {
  if (!value) {
    return '-';
  }

  return `${value.substring(0, 3).toUpperCase()}-${value.substring(3, value.length)}`;
};

export const formatYearModel = (year, model) => {
  if (!(year && model)) {
    return '-';
  }

  return `${year.toString().slice(-2)}/${model.toString().slice(-2)}`;
};

export const toBase64 = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsBinaryString(file);
    reader.onload = () => resolve(btoa(reader.result));
    reader.onerror = error => reject(error);
  });
